export const resetMeTime = {
    id: 'reset-me-time',
    schemaVersion: 2,
    covers: 'One line of copy over a long treatment run. A mood piece — the footage carries it and the words only name the feeling.',
    aspectRatios: ['portrait'],
    duration: {
        kind: 'fixed',
        frames: 384,
    },
    root: {
        kind: 'leaf',
        id: 'main',
        spine: [
            {
                kind: 'media-track',
                id: 'broll',
                duration: {
                    kind: 'fill',
                },
                clips: {
                    source: 'query',
                    query: {
                        kind: 'asset-clips',
                        tag: 'procedure',
                        count: [1, 21],
                    },
                    required: true,
                },
                fit: 'contain-blur',
                kenBurnsOnImages: true,
                cuts: {
                    mode: 'at',
                    at: [
                        {
                            atSec: 0.56,
                            transition: 'cut',
                        },
                        {
                            atSec: 0.96,
                            transition: 'cut',
                        },
                        {
                            atSec: 1.76,
                            transition: 'cut',
                        },
                        {
                            atSec: 1.92,
                            transition: 'cut',
                        },
                        {
                            atSec: 2.08,
                            transition: 'cut',
                        },
                        {
                            atSec: 2.24,
                            transition: 'cut',
                        },
                        {
                            atSec: 2.56,
                            transition: 'cut',
                        },
                        {
                            atSec: 2.84,
                            transition: 'cut',
                        },
                        {
                            atSec: 3.36,
                            transition: 'cut',
                        },
                        {
                            atSec: 3.8,
                            transition: 'cut',
                        },
                        {
                            atSec: 4.24,
                            transition: 'cut',
                        },
                        {
                            atSec: 5.2,
                            transition: 'cut',
                        },
                        {
                            atSec: 6.24,
                            transition: 'cut',
                        },
                        {
                            atSec: 7,
                            transition: 'cut',
                        },
                        {
                            atSec: 7.28,
                            transition: 'cut',
                        },
                        {
                            atSec: 7.6,
                            transition: 'cut',
                        },
                        {
                            atSec: 8,
                            transition: 'cut',
                        },
                        {
                            atSec: 8.4,
                            transition: 'cut',
                        },
                        {
                            atSec: 9.12,
                            transition: 'cut',
                        },
                        {
                            atSec: 9.44,
                            transition: 'cut',
                        },
                        {
                            atSec: 10.16,
                            transition: 'cut',
                        },
                    ],
                },
            },
        ],
        overlays: [
            {
                kind: 'text',
                id: 'statement',
                text: {
                    source: 'query',
                    query: {
                        kind: 'content',
                        field: 'statement',
                    },
                    required: true,
                },
                style: 'display',
                styleOverride: {
                    fontRef: 'inter',
                    colorRole: 'onPrimary',
                    textTransform: 'uppercase',
                    fontSize: 40.6,
                    fontWeight: 400,
                    letterSpacing: 0.01,
                    lineHeight: 1.2,
                    textShadow: '0 2px 12px rgba(0,0,0,0.45)',
                },
                animation: {
                    entrance: 'none',
                },
                duration: {
                    kind: 'fixed',
                    frames: 283,
                },
                start: {
                    at: 'frame',
                    value: 0,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 0.86,
                },
            },
            {
                kind: 'group',
                id: 'card-0',
                start: {
                    at: 'frame',
                    value: 305,
                },
                duration: {
                    kind: 'fixed',
                    frames: 79,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.5,
                    width: 1,
                },
                root: {
                    kind: 'stack',
                    direction: 'v',
                    children: [],
                    container: {
                        background: '#120D07',
                        width: 1080,
                        height: 1920,
                        radius: 0,
                        adoptLogoScrim: true,
                    },
                },
            },
            {
                kind: 'group',
                id: 'brand-card',
                duration: {
                    kind: 'fixed',
                    frames: 79,
                },
                start: {
                    at: 'frame',
                    value: 305,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.505,
                    width: 0.46,
                },
                root: {
                    kind: 'logo',
                    url: {
                        source: 'query',
                        query: {
                            kind: 'brand',
                            field: 'logoUrl',
                        },
                        required: false,
                    },
                    width: 1,
                    entrance: 'none',
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                duration: 3,
                                easing: 'ease-out',
                            },
                            {
                                channel: 'scale',
                                from: 1.06,
                                to: 1,
                                duration: 12,
                                easing: 'ease-out',
                            },
                        ],
                    },
                },
            },
            {
                kind: 'group',
                id: 'brand-card-flash',
                duration: {
                    kind: 'fixed',
                    frames: 79,
                },
                start: {
                    at: 'frame',
                    value: 305,
                },
                placement: {
                    anchor: 'center',
                    x: 0.5,
                    y: 0.505,
                    width: 1,
                },
                root: {
                    kind: 'light',
                    color: '#ffffff',
                    size: 0.95,
                    falloff: 1,
                    intensity: 0.8,
                    entrance: 'none',
                    motion: {
                        tracks: [
                            {
                                channel: 'opacity',
                                from: 0,
                                to: 1,
                                duration: 2,
                                easing: 'ease-out',
                            },
                            {
                                channel: 'opacity',
                                from: 1,
                                to: 0,
                                anchor: {
                                    at: 'start',
                                    frame: 2,
                                },
                                duration: 9,
                                easing: 'ease-in',
                            },
                            {
                                channel: 'scale',
                                from: 0.55,
                                to: 1.35,
                                duration: 11,
                                easing: 'ease-out',
                            },
                        ],
                    },
                },
            },
        ],
    },
    globals: {
        audio: {
            music: {
                source: 'query',
                query: {
                    kind: 'music',
                },
                required: false,
            },
        },
    },
    content: {
        statement: {
            type: 'text',
            maxChars: 36,
            description: 'The single line held across the whole reel: one declarative claim addressed straight at the viewer — something they should act on, not a description of what the footage shows. Wrap the phrase you want stressed in **double asterisks** and those runs render bold. Source shape: "YOUR **BUSINESS NEEDS** A **SALON SUITE**".',
        },
    },
    structure: 'A single declarative claim addressed straight at the viewer, held for the whole reel. Not a slogan and not a description of the footage — an assertion they should act on. The source is: "YOUR BUSINESS NEEDS A SALON SUITE", with "BUSINESS NEEDS" and "SALON SUITE" stepping up to bold.',
};
//# sourceMappingURL=reset-me-time.js.map